import React from "react";
import "./TopBar.css";

const tabTitles = {
  dashboard: "Dashboard",
  cameras: "Cameras",
  alerts: "Alerts",
  settings: "Settings",
};

const TopBar = ({ activeTab, onRefresh }) => {
  return (
    <header className="top-bar">
      <div className="top-bar-main">
        <div className="top-bar-title-group">
          <strong className="top-bar-title">Raspberry Pi Server</strong>
          <span className="top-bar-subtitle">{tabTitles[activeTab] || "Dashboard"}</span>
          <time className="desktop-date">{new Date().toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' })}</time>
        </div>
        {onRefresh && (
          <button type="button" className="top-bar-refresh" onClick={onRefresh} aria-label="Refresh">
            <svg viewBox="0 0 24 24">
              <path d="M23 4v6h-6" />
              <path d="M1 20v-6h6" />
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
            </svg>
          </button>
        )}
      </div>
    </header>
  );
};

export default TopBar;
